// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__1Pwca","tooltip-box":"tooltip_tooltip-box__1JbWm","tooltip-arrow":"tooltip_tooltip-arrow__1HFQp","visible":"tooltip_visible__2mHnd"};